import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'



const Spinner = (props) => {

    return (
        <div id="spinner">
            <h1>...loading</h1>
            <FontAwesomeIcon id="spinnerIcon" icon={faSyncAlt} />
        </div>
        );
    };
    
export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner/index.js